import IframeResizer from 'iframe-resizer-react';
import React, { useEffect } from 'react';

import { useSelector } from '../interfaces/State';
import { ModalSettingsShape } from '../redux/reducers/settings';
import * as selectors from '../redux/selectors';

import DCSpinner from './DCSpinner';

type Props = {
  onExit: () => void;
};

const IframeModal: React.FC<Props> = ({ onExit }) => {
  const modalSettingsImmutable = useSelector(selectors.selectModalSettings);
  const modalSettings: ModalSettingsShape = modalSettingsImmutable.toJS();

  useEffect(() => {
    const onPostMessage = (event: any): void => {
      if (event.data === 'closeDialog') {
        onExit();
      }
    };

    window.addEventListener('message', onPostMessage);
    return () => window.removeEventListener('message', onPostMessage);
  }, [onExit]);

  const { errorMessage, url } = modalSettings;

  if (errorMessage) {
    return <div className="text-center">{errorMessage}</div>;
  }

  if (!url) {
    return <DCSpinner />;
  }

  return (
    <IframeResizer
      className="iframe-modal"
      checkOrigin={[
        'https://upsell-dialogs.datacamp-staging.com',
        'https://upsell-dialogs.datacamp.com',
      ]}
      title="Iframe modal"
      scrolling={true}
      src={url}
      style={{
        minWidth: 'calc(100vw - 32px)',
      }}
    />
  );
};

export default IframeModal;
